import type { DeckDetails } from "@amzn/ads-magneto-typescript-client";

import { zustandStore } from "./zustand.helpers";

export type GlobalWorkbenchState = {
    cartData: DeckDetails | undefined;
};

export interface GlobalWorkbenchActions {
    setCartData: (cartData: DeckDetails | undefined) => void;
    getSlidesSelected: (identifier: string) => number[];
    resetState: () => void;
}

export const initialState: GlobalWorkbenchState = {
    cartData: undefined,
};

export const { store: globalWorkbenchStore } = zustandStore<
    GlobalWorkbenchState,
    GlobalWorkbenchActions
>("GlobalWorkbench", initialState, (set: any, get) => ({
    setCartData: (cartData) => set(() => ({ cartData })),
    getSlidesSelected: (identifier) => {
        const state: GlobalWorkbenchState = get();
        if (!state.cartData?.sources) return [];

        const source = state.cartData.sources.find((source) => {
            const metadata = source.deckMetadata as { [key: string]: any };
            return metadata?.insightIdentifier === identifier;
        });
        return source?.slidesSelected || [];
    },
    resetState: () => set(() => ({ ...initialState })),
}));
